<template>
    <div>
        <div @click="requestPayment">
            <slot></slot>
        </div>
        <services ref="services" @click.stop></services>
        <dialogCode ref="dialogCode" @event="payedDialogEvent"></dialogCode>
    </div>
</template>
<script>
  import App from '../util/comfun'
  import services from './service-dialog.vue'
  import dialogCode from '../components/checkout/dialogCode.vue'
  import env from '../util/env';
  export default {
    props:{
      hasManager:{
        type:Boolean,
        default:false,
      },
      serviceKey:{
        type:String,
        default:'',
      },
      userId:{
        type:String,
        default:'',
      },
      count:{
        type:Number,
        default:1,
      },
      amount:{
        type:String,
        default:"",
      },
      wxpayAct:{//跳到小程序支付后一些溯源判断标识
        type:String,
        default:'',
      }
    },
    data () {
      return {

      }
    },
    components:{
      services,
      dialogCode
    },
    methods:{
      hasTest:App.hasTest,
      usePayBut(){
        let hasiPhone=window.navigator.userAgent.toLocaleLowerCase().indexOf('iphone')>-1
        this.options={from:''}
        try{
          this.options=JSON.parse(decodeURIComponent(this.$route.params.options))
        }catch (e){}
        if(this.options.from=='wxlite' && hasiPhone) {
          //return this.hasManager
          return false
        }
        return true
      },
      requestPayment(){
        this.hasUsePayBut=this.usePayBut()
        //this.hasUsePayBut=true//debug 所有设备都付款
        if(env.isInMiniProgramSync()){//iphone
          //return this.$router.push('/version-iphone/'+this.wxpayAct)
          let url=App.http_build_query({
                params:JSON.stringify({
                serviceKey:this.serviceKey,
                userId:this.userId,
                count:this.count,
                wxpayAct:this.wxpayAct,
              })
            },'/pages/wxpay/wxpay')
          return wx.miniProgram.redirectTo({
            url:url,
          })
        }
        let userAgent=window.navigator.userAgent.toLocaleLowerCase().replace(/[ ]+/g,'')
        if(userAgent.indexOf('macos')>-1 && userAgent.indexOf('wxwork')>-1) {//mac+企微+小程序
          this.hasUseCode=true
        }
        App.demand('/activity/payment/pay','POST',{
          serviceKey:this.serviceKey,
          tradeType:(typeof WeixinJSBridge=='undefined' || this.hasUseCode)?2:1,//
          userId:this.userId,
          count:this.count,
        }).then(res=>{
          this.onBridgeReady(res.data)
          this.hasUseCode=false
        })

      },
      onBridgeReady(params){
        if(typeof WeixinJSBridge=='undefined' || this.hasUseCode){
          this.$refs.dialogCode.show({payParams:params,amount:this.amount})
          //this.$emit('event',{payParams:params,item:this.item,amount:this.amount});
        }else{
          WeixinJSBridge.invoke('getBrandWCPayRequest', {
              "appId": "wx397090124c858e7c",     //公众号ID，由商户传入
              "timeStamp": params.timeStamp,     //时间戳，自1970年以来的秒数
              "nonceStr": params.nonceStr,      //随机串
              "package": "prepay_id="+params.prepayId,
              "signType": params.signType,//"RSA",     //微信签名方式：
              "paySign": params.signStr //微信签名
            },
            (res)=>{
                console.log('WeixinJSBridge',res)
                if(this.hasManager){
                  this.$notify({
                    title: params.prepayId,
                    message: '<div style="word-break: break-all;width: 280px;">'+JSON.stringify(res)+'<br>'+window.navigator.userAgent+"</div>",
                    duration: 0,
                    dangerouslyUseHTMLString: true,
                  });
                  return;
                }
              if(res.err_msg){
                res.err_msg=res.err_msg.toLocaleLowerCase()
                if (res.err_msg == "get_brand_wcpay_request:ok") {
                  // 使用以上方式判断前端返回,微信团队郑重提示：
                  //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                  return this.payedEvent();
                }
                if (res.err_msg.indexOf('cancel')>-1) return

                //发生 system:access_denied 错误且不是手机时显示二维码
                if((res.err_msg.indexOf('system:function_not_implement')>-1
                  || res.err_msg.indexOf('system:access_denied')>-1)
                  && window.navigator.userAgent.toLocaleLowerCase().indexOf('mobile')<0){//二维码
                  this.hasUseCode=true
                  const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                  });
                  return setTimeout(()=>{this.requestPayment();loading.close();},2000)
                }
              }
              //其它全部使用小程序支付，小程序内不允许h5掉支付
              let url=App.http_build_query({
                params:JSON.stringify({
                  serviceKey:this.serviceKey,
                  userId:this.userId,
                  count:this.count,
                  wxpayAct:this.wxpayAct,
                })
              },'/pages/wxpay/wxpay')
              return wx.miniProgram.redirectTo({
                url:url,
              })

            }
          );
        }
      },
      payedEvent(){
        this.$emit('event',{payed:true,item:this.item});
      },
      payedDialogEvent(e){
        this.$emit('event',e);
      }
    },
    created(){

    },
  }
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/requestPayment.vue